module.exports = __webpack_public_path__ + "img/202.de45804e.png";